import { RESENDVERIFICATION_SUCCESS, RESENDVERIFICATION_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const resendVerficationReducer = (state = initialState, action) => {
    switch (action.type) {
        case RESENDVERIFICATION_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case RESENDVERIFICATION_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default resendVerficationReducer;
